import React, { createContext, useContext, ReactNode } from "react";
import type { SortPreset } from "../constants/config/sort";

interface SortContextValue {
  currentSort: SortPreset | null;
  onSelect: (preset: SortPreset | null) => void;
}

const SortContext = createContext<SortContextValue | null>(null);

interface SortProviderProps {
  currentSort: SortPreset | null;
  onSelect: (preset: SortPreset | null) => void;
  children: ReactNode;
}

export const SortProvider: React.FC<SortProviderProps> = ({
  currentSort,
  onSelect,
  children,
}) => {
  return (
    <SortContext.Provider value={{ currentSort, onSelect }}>
      {children}
    </SortContext.Provider>
  );
};

export const useSort = (): SortContextValue => {
  const context = useContext(SortContext);
  if (!context) {
    return { currentSort: null, onSelect: () => {} };
  }
  return context;
};
